__turbopack_context__.v({
  "active": "treemap-module__jGQePW__active",
  "callout": "treemap-module__jGQePW__callout",
  "catLabel": "treemap-module__jGQePW__catLabel",
  "chip": "treemap-module__jGQePW__chip",
  "controls": "treemap-module__jGQePW__controls",
  "ctrl": "treemap-module__jGQePW__ctrl",
  "ctrlLabel": "treemap-module__jGQePW__ctrlLabel",
  "dlPhoto": "treemap-module__jGQePW__dlPhoto",
  "exporting": "treemap-module__jGQePW__exporting",
  "footer": "treemap-module__jGQePW__footer",
  "leaf": "treemap-module__jGQePW__leaf",
  "leafRect": "treemap-module__jGQePW__leafRect",
  "leafText": "treemap-module__jGQePW__leafText",
  "left": "treemap-module__jGQePW__left",
  "legend": "treemap-module__jGQePW__legend",
  "lgLayer": "treemap-module__jGQePW__lgLayer",
  "logo": "treemap-module__jGQePW__logo",
  "neg": "treemap-module__jGQePW__neg",
  "note": "treemap-module__jGQePW__note",
  "pos": "treemap-module__jGQePW__pos",
  "reset": "treemap-module__jGQePW__reset",
  "root": "treemap-module__jGQePW__root",
  "seg": "treemap-module__jGQePW__seg",
  "select": "treemap-module__jGQePW__select",
  "stackHeader": "treemap-module__jGQePW__stackHeader",
  "stackRow": "treemap-module__jGQePW__stackRow",
  "stackSwatch": "treemap-module__jGQePW__stackSwatch",
  "sub": "treemap-module__jGQePW__sub",
  "svg": "treemap-module__jGQePW__svg",
  "sw": "treemap-module__jGQePW__sw",
  "tip": "treemap-module__jGQePW__tip",
  "tipCat": "treemap-module__jGQePW__tipCat",
  "tipK": "treemap-module__jGQePW__tipK",
  "tipName": "treemap-module__jGQePW__tipName",
  "tipRow": "treemap-module__jGQePW__tipRow",
  "title": "treemap-module__jGQePW__title",
  "warn": "treemap-module__jGQePW__warn",
  "wrap": "treemap-module__jGQePW__wrap",
  "zero": "treemap-module__jGQePW__zero",
});
